import httpClient from "@/services/httpClient";
import {
    server, trademark_const
} from "@/services/constants";


export const getdocumenttypeAll = () => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.DOCUMENTTYPE + `/getdocumenttypeAll`);
};
export const getdocumenttypeList = () => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.DOCUMENTTYPE + `/getdocumenttypeList`);
};

export const getdocumenttype_code = () => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.DOCUMENTTYPE + `/getdocumenttype_code`);
};

export const getdocumenttype_ptcode = () => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.DOCUMENTTYPE + `/getdocumenttype_ptcode`);
};

export const getdocumenttype_codeByobjecttype_id = (id) => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.DOCUMENTTYPE + `/getdocumenttype_code_byobjecttype_id/${id}`);
};

export const getdocumenttypeByID = (id) => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.DOCUMENTTYPE + `/getdocumenttypebyid/${id}`);
};